import React, { useState } from 'react';
import { DATA_TEST_IDS, POSTER_HEIGHT, POSTER_WIDTH } from '../consts';
import type { MediafilePosterImageProps } from './types';
import styles from '../index.module.scss';

export const MediafilePosterImage: React.FC<MediafilePosterImageProps> = ({ src, fallbackSrc, alt, id }) => {
  const [failedSources, setFailedSources] = useState<string[]>([]);
  const imageSrc = [src, fallbackSrc].find((candidate) => candidate && !failedSources.includes(candidate));
  return !imageSrc ? null : (
    <img
      src={imageSrc}
      alt={alt}
      width={POSTER_WIDTH}
      height={POSTER_HEIGHT}
      loading="lazy"
      className={styles.image}
      data-testid={DATA_TEST_IDS.IMAGE(id)}
      onError={() => setFailedSources((current) => [...current, imageSrc])}
    />
  );
};
